import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_98: FaireProductEntity = {
  token: "catalog_prod_prod-98",
  type: "product",
  name: "Candle Holder",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=400&h=400&fit=crop",
  priceDollars: 78.43,
  msrpDollars: 196.08,
  sku: "CA0098",
  caseSize: 2,
  material: "Metal",
  collectionToken: "col_camp",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 285,
  description: "Beautiful Camp! piece perfect for any home.",
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
